module.exports = __webpack_public_path__ + "static/media/TC_KSS_draft_v5_04.06.2021.593697a2.pdf";